<template>
  <rest-list-page :page-title="pageTitle" :fetch-endpoint="fetchEndpoint">
    <template slot="actions">
      <router-link :to="createRoute">
        <el-button type="primary" icon="el-icon-plus">
          {{ $t('Events_EventList_Create') }}
        </el-button>
      </router-link>
    </template>

    <template slot="table">
      <rest-list-column
        prop="name"
        filter-field="title"
        sort-field="title"
        :title="$t('Events_Field_Title')"
      ></rest-list-column>

      <rest-list-column-boolean
        prop="store_event_hit"
        :title="$t('Events_StoreEventHit_Title')"
        :tooltip-text="$t('DataManager_Events_Field_StoreEventHit_Description')"
      ></rest-list-column-boolean>

      <rest-list-column-actions v-if="readonly">
        <template slot-scope="scope">
          <rest-list-action-view :route="rowViewRoute(scope.row)" />
        </template>
      </rest-list-column-actions>

      <rest-list-column-actions v-else>
        <template slot-scope="scope">
          <rest-list-action-update :route="rowUpdateRoute(scope.row)" />
          <rest-list-action-delete
            :endpoint="rowDeleteEndpoint(scope.row)"
            :name="scope.row.name"
          />
        </template>
      </rest-list-column-actions>
    </template>
  </rest-list-page>
</template>

<script>
import RestListPage from '@/common/components/rest/RestListPage'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnBoolean from '@/common/components/rest/RestListColumnBoolean'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionUpdate from '@/common/components/rest/RestListActionUpdate'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import RestListActionView from '@/common/components/rest/RestListActionView'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  name: 'EventListPage',

  components: {
    RestListPage,
    RestListColumn,
    RestListColumnBoolean,
    RestListColumnActions,
    RestListActionView,
    RestListActionDelete,
    RestListActionUpdate
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `events`,
        params: {}
      })
    },

    createRoute() {
      return projectRoute({
        name: 'EventCreate'
      })
    },

    readonly() {
      return !this.$can('manageProjectTechnical')
    }
  },

  methods: {
    rowUpdateRoute(row) {
      return projectRoute({
        name: 'EventUpdate',
        query: { id: row.id }
      })
    },

    rowViewRoute(row) {
      return projectRoute({
        name: 'EventView',
        query: { id: row.id }
      })
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `events/${row.id}`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/events/pages/EventListPage.vue